import React, { useCallback, useEffect } from "react";
import { AlertTriangle, Trash2, X } from "lucide-react";

export function RemoveDevicePopup({
    title,
    onSubmit,
    onCancel,
    closePopup,
    deviceCount = 1
}) {
    const handleClose = useCallback(() => {
        onCancel && onCancel();
        closePopup();
    }, [onCancel, closePopup]);

    useEffect(() => {
        document.body.style.overflow = "hidden";

        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClose();
            }
        };

        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = "";
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [handleClose]);

    const handleConfirm = () => {
        onSubmit && onSubmit();
        closePopup();
    };

    const deviceLabel = deviceCount > 1 ? "devices" : "device";

    return (
        <div className="oct-remove-device-modal" role="dialog" aria-modal="true" aria-labelledby="oct-remove-device-title">
            <div className="oct-remove-device-modal__backdrop" onClick={handleClose} />

            <div className="oct-remove-device-modal__dialog" onClick={(event) => event.stopPropagation()}>
                <div className="oct-remove-device-modal__header">
                    <div className="oct-remove-device-modal__header-glow" />

                    <div className="oct-remove-device-modal__title-group">
                        <div className="oct-remove-device-modal__title-icon">
                            <Trash2 size={20} />
                        </div>

                        <h4 id="oct-remove-device-title" className="oct-remove-device-modal__title">
                            {title || "Remove Device"}
                        </h4>
                    </div>

                    <button
                        type="button"
                        className="oct-remove-device-modal__close"
                        onClick={handleClose}
                        aria-label="Close remove device popup"
                    >
                        <X size={16} />
                    </button>
                </div>

                <div className="oct-remove-device-modal__body">
                    <div className="oct-remove-device-modal__warning-icon-wrap">
                        <div className="oct-remove-device-modal__warning-icon-shadow" />
                        <div className="oct-remove-device-modal__warning-icon">
                            <AlertTriangle size={38} strokeWidth={2.4} />
                        </div>
                    </div>

                    <div className="oct-remove-device-modal__content">
                        <h5 className="oct-remove-device-modal__heading">Are you sure?</h5>

                        <p className="oct-remove-device-modal__message">
                            You are about to remove{" "}
                            <strong>{deviceCount} {deviceLabel}</strong>{" "}
                            from your system. This action cannot be undone.
                        </p>
                    </div>

                    <div className="oct-remove-device-modal__note">
                        <AlertTriangle size={18} className="oct-remove-device-modal__note-icon" />
                        <p>
                            <strong>Warning:</strong> All device data, configurations, and historical records will be permanently deleted.
                        </p>
                    </div>
                </div>

                <div className="oct-remove-device-modal__footer">
                    <button
                        type="button"
                        className="btn oct-remove-device-modal__btn oct-remove-device-modal__btn--secondary"
                        onClick={handleClose}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="btn oct-remove-device-modal__btn oct-remove-device-modal__btn--danger"
                        onClick={handleConfirm}
                    >
                        <Trash2 size={16} />
                        Remove {deviceCount > 1 ? "Devices" : "Device"}
                    </button>
                </div>
            </div>
        </div>
    );
}
